import { loadReportsIndicatorsRepo, exportReportRepo } from "../repository/ReportsRepository";

// UpSales.InteractionReport.countByModeKPIs(companyId, userId, dateFrom, dateTo)
export const loadReportsIndicators = async (companyId, userId, dateFrom, dateTo, countryId, provinceId, localityId, postalCode) => {
    try {
      let response = await loadReportsIndicatorsRepo(companyId, userId, dateFrom, dateTo, countryId, provinceId, localityId, postalCode)
      return response;
    } catch (error) {
      console.log("ERROR Reports-REPO: loadReportIndicatorsRepo: ", error);
      throw Error(error);
    }
  };

// UpSales.InteractionReport.countByModeCompanyTableExportExcel(dateFrom, dateTo, filename)
export const exportReport = async (dateFrom, dateTo, filename) => {
  try {
    let response = await exportReportRepo(dateFrom, dateTo, filename)
    return response;
  } catch (error) {
    console.log("ERROR Reports-REPO: exportReport: ", error);
    throw Error(error);
  }
};